"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _RatingAndReviewDialog = require("./RatingAndReviewDialog");
Object.keys(_RatingAndReviewDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RatingAndReviewDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RatingAndReviewDialog[key];
    }
  });
});
var _ResultDialog = require("./ResultDialog");
Object.keys(_ResultDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ResultDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ResultDialog[key];
    }
  });
});
var _Snackbar = require("./Snackbar");
Object.keys(_Snackbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Snackbar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Snackbar[key];
    }
  });
});
